/* START: WebinarPodcast Toggle */

var toggleButtons = document.querySelectorAll('.page-header .page-header__toggle-buttons .toggle-buttons button');

for (var i = 0; i < toggleButtons.length; i++) {
	toggleButtons[i].addEventListener('click', toggleWebinarPodcast)
}

function toggleWebinarPodcast(e) {
	document.querySelector('.page-header .page-header__toggle-buttons .toggle-buttons .selected').classList.remove('selected');
	e.target.classList.add('selected');
	console.log(e.target);
	if (e.target.classList.contains('toggle-buttons__right')) {
		document.querySelector('.webinar-list').classList.remove('hidden-posts');
		document.querySelector('.podcast-list').classList.add('hidden-posts');
	} else {
		document.querySelector('.webinar-list').classList.add('hidden-posts');
		document.querySelector('.podcast-list').classList.remove('hidden-posts');

	}
}